module.exports = __webpack_public_path__ + "static/img/DARCY-WILSON.fa78bae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DARCY-WILSON.jpg
// module id = D10e
// module chunks = 0